import './index.scss';
import React from 'react';
import Results from './results';
const CenterPanel = () => {
    return (React.createElement("div", { className: 'center-panel' },
        React.createElement(Results, null)));
};
export default CenterPanel;
